<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import payment_methods from '@/assets/json/payment-methods';

export default {
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      modal_title: '',
      action: '',
      currency: '',
      invoice_id: null,
      invoice_number: '',
      invoice_type: '',
      amount: '',
      payment_method: null,
      payment_date: '',
      customer_id: '',
      unallocated_amount: 0,
      notes: '',
      mass_delete: false,
      users: [],
      errors: {},
      app_currency: '',
      transaction_id: '',
      payment_detail: [],
      payment_methods: payment_methods,
    };
  },

  computed: {
   allocateAmount(){
    if(this.unallocated_amount < this.amount){
     return this.unallocated_amount;
    }
    return this.amount;
   }
  },

 async mounted(){ 
   this.payment_date = this.$currentDate();
   this.app_currency = await this.$appCurrency();
  },

 methods: { 

  receive(invoice_id, invoice_number, customer_id, balance, invoice_type, title){
   this.resetForm();
   this.invoice_id = invoice_id;
   this.invoice_number = invoice_number;
   this.invoice_type = invoice_type;
   this.customer_id = customer_id; 
   this.modal_title = title; 
   this.amount = balance.toFixed(2);
   this.unallocatedAmount(); 
  },  
   
  async submitPayment() {
   this.setLoading(true);
   this.errors = {};
    try{
     const payload = {
      user_id: this.auth.id,  
      amount: this.amount,
      payment_method: this.payment_method,
      transaction_id: this.transaction_id,
      payment_date: this.payment_date,
      notes: this.notes
     };
     const document_module = (this.invoice_type === 'Invoice') ? "invoices" : "proforma-invoices";
     const response = await axios.post(`/${document_module}/${this.invoice_id}/receive-payment`, payload);
     //this.unallocated_amount = response.data;
     console.log(response.data);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('payment_receive_modal');
     this.resetForm();
    }catch(error){
     if(error?.type === 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false);
    }
  },

  async unallocatedAmount(){
   try{
    const response = await axios.get(`/payments/customer/${this.customer_id}/unallocated-total`);
    this.unallocated_amount = response.data.data.total_unallocated_amount;
   }catch(error){
    this.$swalToast(error.message, 'error'); 
   } 
  },

  async allocatePayment(){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.errors = {};
    this.setLoading(true);
    try{
    const payload = {
     invoice_id: this.invoice_id,
     invoice_type: this.invoice_type,
     amount: this.unallocated_amount  
    };
    const response = await axios.patch(`/payments/customer/${this.customer_id}/allocate-unallocated-to-invoice`, payload);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('payment_receive_modal');
     this.resetForm();
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  }
  },

  async detail(id, transaction_id, notes){
   this.setLoading(true);
   try{
    this.notes = notes;
    this.transaction_id = transaction_id;
    const response = await axios.get(`/payments/${id}`);
    this.payment_detail = response.data.data;
    this.modal_title = `Payment: ${this.app_currency.code} ${this.payment_detail.total_amount}`;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  documentURL(document_type, token){
   let type = (document_type === "App\\Models\\Invoice") ? 'invoices' : 'proforma-invoices';
   return `/sales/${type}/view/${token}`;
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.errors = {}; 
   this.amount = '';
   this.payment_method = '';
   this.transaction_id = '';
   this.payment_date = this.$currentDate();
   this.notes = '';
  }

 }
};
</script>

<template>

 <!-- RECEIVE -->
<div class="modal fade" id="payment_receive_modal">
  <div class="modal-dialog modal-dialog-centered modal-md w-100">
  <div class="modal-content">
  <div class="modal-header">
  <h4 class="modal-title">{{modal_title}}</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"> <i class="ti ti-x"></i></button>
  </div>
  <div class="modal-body pb-0">

   <div class="row">
    <div class="col-md-12">
    <form @submit.prevent="allocatePayment"> 
      <div class="card">
       <div class="card-header">
        <h6 class="card-title">Allocate Payment to <span class="text-primary">{{ invoice_number }}</span></h6>
       </div>
       <div class="card-body">
        <h6 class="mb-2">Balance amount: <span class="text-info">{{app_currency.code}} {{amount}}</span></h6>
        <h6>Unallocated amount: <span :class="(unallocated_amount > 0) ? 'text-success' : 'text-danger'">{{app_currency.code}} {{unallocated_amount}}</span></h6> 
       

        </div>
        <div class="card-footer" v-if="unallocated_amount">
         <button type="submit" class="btn btn-primary btn-sm">Allocate {{app_currency.symbol}}{{ allocateAmount }}</button>   
        </div>

      </div>
      </form>
     </div>

    </div>
    
    <div class="row">
    <div class="col-md-12">
    <form @submit.prevent="submitPayment"> 
      <div class="card">
       <div class="card-header">
        <h6 class="card-title">Add Payment</h6>
       </div>
       <div class="card-body">
      
        <div class="row">
        <div class="col-md-5">
        <label class="form-label">Amount</label>
        <input type="text" class="form-control" v-model="amount" />
        <div v-if="errors.amount" class="text-danger small mt-1">{{ errors.amount[0] }}</div>
        </div>
        <div class="col-md-7 custom-vueselect">
        <label class="form-label">Payment Method</label>
        <vue-select v-model="payment_method" :options="payment_methods" placeholder="Payment Methods" />
        <div v-if="errors.payment_method" class="text-danger small mt-1">{{ errors.payment_method[0] }}</div>
        </div>
        <div class="col-md-6 mt-2">
        <label class="form-label">Transaction ID</label>
        <input type="text" class="form-control" v-model="transaction_id" />
        <div v-if="errors.transaction_id" class="text-danger small mt-1">{{ errors.transaction_id[0] }}</div>
        </div>
        <div class="col-md-6 mt-2">
        <label class="form-label">Payment Date</label>
        <input type="date" class="form-control" v-model="payment_date" />
        <div v-if="errors.payment_date" class="text-danger small mt-1">{{ errors.payment_date[0] }}</div>
        </div>
        <div class="col-md-12 mt-2">
        <label class="form-label">Notes</label>
        <textarea type="text" class="form-control" v-model="notes"></textarea>
        <div v-if="errors.notes" class="text-danger small mt-1">{{ errors.notes[0] }}</div>
        </div>
        </div>

        </div>
        <div class="card-footer">
         <button type="submit" class="btn btn-primary btn-sm">Submit</button>   
        </div>

      </div>
      </form>
     </div>

    </div>


   </div> 

  </div>
  </div>
  </div>
<!-- RECEIVE -->   

<!-- View Details -->
<div class="modal fade" id="payment_detail_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header bg-dark">
<h4 class="modal-title text-white">{{modal_title}}</h4>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">
<h5 class="mb-2">Payment Details</h5>
<div class="border rounded mb-3 p-2">
<div class="row row-gap-3">
 <div class="col-md-4">
 <div class="text-center">
   <span class="d-block mb-1 fw-bold">Allocated Amount</span>
   <p class="text-dark fw-normal">{{ payment_detail.allocated_amount }}</p>
 </div>
 </div>
 <div class="col-md-5">
 <div class="text-center">
    <span class="d-block mb-1 fw-bold">Un-Allocated Amount</span>
    <p class="text-dark fw-normal">{{ payment_detail.unallocated_amount }}</p>
 </div>
 </div>
 <div class="col-md-3">
 <div class="text-center">
 <span class="d-block mb-1 fw-bold">Allocation (%)</span>
  <span class="badge bg-soft-pink d-inline-flex align-items-center">
  <i class="fas fa-circle fs-6 me-1"></i>{{ payment_detail.allocation_percentage }}</span>
 </div>
 </div>
</div>
</div>

 <div class="mb-3" v-if="transaction_id || notes">
 <h5 class="mb-2">Notes</h5>
 <p v-if="transaction_id"><span>Transaction ID :</span> {{ transaction_id }} </p>
 <p v-html="notes"></p>
 </div>

 <div class="schedule-timeline" v-if="payment_detail?.allocations?.length">

  <div class="d-flex align-items-center" v-for="(row, index) in payment_detail.allocations" :key="index">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-dark">{{ $formatDate(row.invoice_date, 'DD-MM-YY') }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">
    <a :href="documentURL(row.allocatable_type, row.invoice_token)" target="_blank"> {{ row.invoice_number }} </a>
    </p>
    <span class="me-2">{{ row.invoice_amount }}</span>
    <span class="badge rounded-pill bg-outline-secondary">{{ row.invoice_status }}</span>
   </div>
  </div>
  </div>
   
  <div class="d-flex align-items-center">
    <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
  </div>
</div>

</div>
</div>
</div>
</div>
<!-- /View Details -->

</template>